import { render } from "./PaywallTransactionDetailsModal.vue?vue&type=template&id=4ba068c0"
import script from "./PaywallTransactionDetailsModal.vue?vue&type=script&lang=js"
export * from "./PaywallTransactionDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/PaywallTransactionDetailsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ba068c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ba068c0', __exports__)) {
    api.reload('4ba068c0', __exports__)
  }
  
  module.hot.accept("./PaywallTransactionDetailsModal.vue?vue&type=template&id=4ba068c0", () => {
    api.rerender('4ba068c0', render)
  })

}


export default __exports__